import styled from "styled-components";

export const StyledNotFound = styled.div`
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  padding: 48px 0px;
  width: 100%;

  .not-found-text {
    padding: 24px 32px;
    border-radius: 8px;
    background: rgba(15, 17, 26, 0.55);
    text-align: center;
    text-transform: uppercase;
    color: rgb(103, 109, 124);
    font-size: 18px;
    font-weight: 800;
    font-style: normal;
  }
`;
